"use client";

import { useEffect, useRef } from "react";
import { trackAnalyticsEvent } from "@/lib/analytics/track";

export interface IBlogContentTrackerProps {
  slug: string;
  title: string;
}

/** Fires consent-gated ViewContent once when a blog post is viewed. */
export function BlogContentTracker({
  slug,
  title,
}: IBlogContentTrackerProps): React.ReactElement | null {
  const fired = useRef(false);

  useEffect(() => {
    if (fired.current) return;
    fired.current = true;
    trackAnalyticsEvent("view_content", {
      content_type: "blog_post",
      content_name: `${slug}:${title}`,
    });
  }, [slug, title]);

  return null;
}
